import { useState, type ReactElement } from "react";
import { Box, DoorAccessIcon, ExclusionListIcon, NavDrawer, Text } from "@citibox-panel/ui";

// TODO: i18n — copy en ES hasta Fase 1.
// Fragment-only hrefs: routes.tsx owns every path, so the demo names none.
const ITEMS = [
  { href: "/#door-access", label: "Amazon Access", icon: <DoorAccessIcon /> },
  { href: "/#exclusion", label: "Listas de exclusión", icon: <ExclusionListIcon /> },
] as const;

// Never leaves the kit: `onNavigate` only moves the current entry.
export function NavDrawerDemo(): ReactElement {
  const [current, setCurrent] = useState<string>(ITEMS[0].href);
  const [collapsed, setCollapsed] = useState(false);
  return (
    <>
      <Text variant="body2" color="secondary" gutterBottom>
        Menú lateral permanente y plegable (<code>NavDrawer</code>): enlaces reales, entrada actual con{" "}
        <code>aria-current</code> y tooltip a la derecha cuando está plegado.
      </Text>
      {/* Bounded box: the drawer is sized against the viewport under the surface header. */}
      <Box sx={{ display: "flex", height: 240, overflow: "hidden", border: 1, borderColor: "divider" }}>
        <NavDrawer
          aria-label="Menú de ejemplo"
          items={ITEMS.map((item) => ({ ...item, current: item.href === current }))}
          onNavigate={setCurrent}
          collapsed={collapsed}
          onCollapsedChange={setCollapsed}
          collapseLabel="Contraer menú"
          expandLabel="Expandir menú"
        />
      </Box>
    </>
  );
}
